import { Suspense } from 'react';

import { WidgetPlaceholder } from '../../widgets-elements/WidgetPlaceholder';

import Styles from './index.module.scss';

import { ErrorBoundary } from '@/components/Elements/ErrorBoundary';


interface Props<T> {
	data: T;
	title: string;
	subtitle?: string;
	children?: (data: NonNullable<T>) => React.ReactNode;
	isLoading?: boolean;
	loadingElement?: React.ReactNode;
	errorElement?: React.ReactNode;
	noDataElement?: React.ReactNode;
	actions?: React.ReactNode;
	headerStyle?: React.CSSProperties;
	chartStyle?: React.CSSProperties;
}

export const ChartWidget = <T,>({
	title,
	children,
	isLoading,
	data,
	subtitle,
	actions = <></>,
	loadingElement = <WidgetPlaceholder state="loading" />,
	noDataElement = <WidgetPlaceholder state="no-data" />,
	errorElement = <WidgetPlaceholder state="error" />,
	headerStyle,
	chartStyle,
}: Props<T>) => {
	let body: React.ReactNode = <></>;
	if (isLoading) {
		body = loadingElement;
	} else if (!data || (Array.isArray(data) && data.length === 0)) {
		body = noDataElement;
	} else if (children) {
		body = children(data);
	} else {
		body = noDataElement;
	}

	return (
		<div className={Styles.container}>
			<div className={Styles.header}>
				<div className={Styles.title}>
					<p style={headerStyle}>{title}</p>
					<div className={Styles.actions}>{!isLoading && actions}</div>
				</div>
				{subtitle && (
					<div className={Styles.subtitle}>
						<span>{subtitle}</span>
					</div>
				)}
			</div>

			<div className={Styles.body} style={chartStyle}>
				<ErrorBoundary errorElement={errorElement}>
					<Suspense fallback={loadingElement}>{body}</Suspense>
				</ErrorBoundary>
			</div>
		</div>
	);
};
